// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"9d031034","195":"e9aae421","282":"f4edd871","453":"347095ef","796":"c2b48900","966":"f055ef7c"}[chunkId] + ".chunk.js";
};